import React, { FC } from 'react';
import classNames from 'classnames';
import { Trans, useTranslation } from '@blocs.i18n';
import { BasicContainer, BodyTextSmall, DetailTextLarge, FlexCol, FlexRow } from '@minecraft.atoms';
import { appConfig } from '@minecraft.app-config';

type TestimonialCardProps = {
  fullWidth?: boolean;
  image?: string;
  author?: string;
  message?: string;
  memberSince?: string;
  textSize?: 'sm' | 'md';
  withShadow?: boolean;
  bgColor?: 'cardLightContrast' | 'warmPaywallLightBg';
  borderColor?: 'paywallVanilla' | 'warmPaywall';
  bgOpacity?: number;
};

export const TestimonialCard: FC<TestimonialCardProps> = React.memo(
  ({
    fullWidth,
    image,
    author,
    message,
    memberSince,
    textSize = 'md',
    withShadow = true,
    bgColor = 'cardLightContrast',
    borderColor,
    bgOpacity,
  }) => {
    const { t } = useTranslation();
    const Text = textSize === 'sm' ? DetailTextLarge : BodyTextSmall;
    return (
      <FlexCol
        gap="2"
        mdProps={{ direction: 'row', mt: '0' }}
        wrap="nowrap"
        justifyContent="flex-end"
        w="full"
        mt="4"
        mb="8"
        maxW={fullWidth ? 'full' : '96'}
        className={classNames('cn_relative', {
          'cn_shadow-md': withShadow,
        })}
        borderRadius="md"
        borderPlacement={borderColor ? 'all' : undefined}
        bgColor={bgColor}
        bgOpacity={bgOpacity}
        borderColor={borderColor}
      >
        <FlexRow w="full" m="auto" borderRadius="full" className="cn_absolute" top={-2} justifyContent="center">
          <BasicContainer
            borderPlacement="all"
            borderSize={0.1}
            borderColor="paywallVanilla"
            borderRadius="full"
            className="cn_shadow-md"
          >
            <img
              src={`${appConfig.cdnRoot}/images/static/${image ?? 'testimonial-author-allison.png'}`}
              alt="icon"
              className="cn_atom_rounded-full"
            />
          </BasicContainer>
        </FlexRow>

        <FlexCol mt="6" className="cn_atom_px-4 cn_atom_pt-2 cn_atom_pb-3" gap="4" wrap="nowrap">
          <FlexRow justifyContent="center" alignItems="center" m="auto" gap="1" wrap="nowrap">
            <Text as="p" align="center">
              {message ?? t('common:paywall.testimonial.message.allison')}
            </Text>
          </FlexRow>
          <FlexRow justifyContent="center" alignItems="center" m="auto" gap="1">
            <Trans
              i18nKey="paywall.testimonial.author"
              values={{
                name: author ?? 'Allison Blackman',
                member: memberSince ?? '2020',
              }}
              components={{
                name: <BodyTextSmall fontWeight="bold" />,
                member: <Text as="p" />,
              }}
            />
          </FlexRow>
        </FlexCol>
      </FlexCol>
    );
  }
);
